import { AuthenticationService } from './../../services/authentication/authentication.service';
import { Inject, Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { RoutePermissionAction, RoutePermissionCategory, RoutePermissionGroup, RoutePermissions } from './definitions';
import { get as lodashGet, noop as lodashNoop } from 'lodash';
import { AppConstants, expAppConstants } from '../../constants/portal-constants';
import { Image } from '../../services/shared/shared-interface';
import { HttpErrorResponse } from '@angular/common/http';
import { SharedService } from '../../services/shared/shared.service';
import { CommonErrorService } from '../../components/common-error';
import { SharedUtilService } from '../../services/shared/shared-util.service';
import { accountManagerRoleId, individualUserPermissionMessage, individualUserRoleId } from '../../services/shared/shared-constants';
import { ApplicationPath } from '../../services/shared/shared-enums';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';

@Injectable({
	providedIn: 'root'
})
export class PermissionGuard implements CanActivate
{
	constructor(
    private authenticationService: AuthenticationService,
    private router:Router,
	private sharedService: SharedService,
	private localStorageService: LocalStorageService,
	private errorService: CommonErrorService,
	private sharedUtilService: SharedUtilService,
	@Inject(expAppConstants) readonly appConstantsRef: AppConstants) 
	{}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean>
	{
		const isTmhCustomerSupportRole = this.localStorageService.getCustomerToDashboard();
		if(this.localStorageService.getTmhCorporateAdminDetails() === null || isTmhCustomerSupportRole)
		{
			return new Observable<boolean>(subscriber =>
			{
				const routePermissionsPath: string = 'data.permissions';
				const defaultPermissions: RoutePermissionGroup = { category: 'NONE' as RoutePermissionCategory, action: 'NONE' as RoutePermissionAction };
				const group: RoutePermissionGroup = lodashGet(route, routePermissionsPath, defaultPermissions);
				this.authenticationService.getRoutePermissions(route).subscribe({
					next: (response: RoutePermissions) =>
					{
						const actions: RoutePermissionAction[] = response.actions;
						const hasAccess: boolean = actions.includes(group.action) || false;
						hasAccess ? this.authenticationService.setRoutePermissions(group, { category: group.category, actions }) : lodashNoop();
						if(this.isAccountManagerRole(route.url[0]?.path))
							this.triggerErrorService('Permission Required', 401, '000026');
						subscriber.next(hasAccess);
						subscriber.complete();
					},
					error: (error: HttpErrorResponse) =>
					{
						this.redirectOnError(error);
						subscriber.next(false);
						subscriber.complete();
					}
				});
			});
		}
		return of(false);
	}

	isAccountManagerRole(url: string): boolean
	{
		if(this.sharedService.getRoleId() === accountManagerRoleId)
		{
			if(url?.includes('adduser'))
				return true;
		}
		return false;
	}

	private redirectOnError(error: HttpErrorResponse) 
	{
		this.triggerErrorService('Permission Required', 401, error?.error?.id);
	}
	private triggerErrorService(status: string, statusCode: number, id:string) 
	{ 
		const image: Image = this.sharedUtilService.setImageBasedOnStatusCode(statusCode);
		const roleId = this.sharedService.getRoleId();
		const contactMessage: string = (roleId === individualUserRoleId) ? individualUserPermissionMessage :
			(roleId === accountManagerRoleId) ? '' : this.sharedService.updateGetAdminEmail(this.sharedUtilService.getMessage()) + '.';
		this.errorService.updateState({ messages: [{ message: status }, { message: contactMessage, cssClass: 'error-contact-section' }], statusCode: statusCode, id: id, image: image });
		this.sharedService.navigateMethod(this.router, ApplicationPath.authError);
	}
}
